import { render } from "./ClientCompanies.vue?vue&type=template&id=fdc3f8f0"
import script from "./ClientCompanies.vue?vue&type=script&lang=js"
export * from "./ClientCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__